import React from 'react';
import { useTranslation } from 'react-i18next';

export function Created() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <div className="flex w-full shrink-0 justify-center bg-gray-700 px-4 py-3">
      <p className="max-w-full break-words text-center text-xs text-white sm:text-sm md:text-base">
        {t('created.texto', { year })}
      </p>
    </div>
  );
}

export default Created;
